import { useEffect } from "react";
import { useMap } from "react-leaflet";
import { AdaptiveImageryLayer, IMAGERY_MAX_ZOOM } from "../utils/adaptiveImagery";

export default function AdaptiveSatelliteLayer({ url, attribution }) {
  const map = useMap();
  useEffect(() => {
    const layer = new AdaptiveImageryLayer(url, {
      attribution, maxNativeZoom: IMAGERY_MAX_ZOOM, maxZoom: IMAGERY_MAX_ZOOM,
      updateWhenIdle: true, keepBuffer: 1,
    });
    layer.addTo(map);
    return () => layer.remove();
  }, [map, url, attribution]);
  return null;
}
